import { useEffect, useRef, useState } from "react";

/**
 * Animated count-up from 0 → target when in view.
 * @param {number} target  - final numeric value
 * @param {number} duration - ms
 * @param {boolean} active - whether to start
 */
export const useCountUp = (target, duration = 1600, active = true) => {
  const [value, setValue] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    if (!active || started.current) return;
    started.current = true;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      setValue(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [target, duration, active]);

  return value;
};
